import { addHocItem } from "@/api/other-deduction-items";
import Dropdown, { Item } from "@/components/form/Dropdown";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import {
  OtherDeductionItem,
  OtherDeductionItemType,
  OtherDeductionItemTypeLabels,
} from "@/models/other-deduction-items.model";
import React, { useState } from "react";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
  updateOtherDeductionItems: (item: OtherDeductionItem) => void;
}

export const otherDeductionItemTypeArray: Item[] = Object.values(
  OtherDeductionItemType
).map((value) => ({
  value: value,
  label: OtherDeductionItemTypeLabels[value],
}));

function AddOtherDeductionForm({
  userId,
  month,
  year,
  payslipId,
  updateOtherDeductionItems,
}: Props) {
  const [type, setType] = useState<string>("");
  const [amount, setAmount] = useState<number>(0);
  const [err, setErr] = useState<string>("");
  const isValid = () => {
    if (type === "" || amount === 0) {
      setErr("Please fill all fields.");
      return false;
    }
    if (amount <= 0) {
      setErr("Amount must be greater than 0.");
      return false;
    }
    setErr("");
    return true;
  };

  const handleOtherDeductionItem = async () => {
    if (!isValid()) {
      return;
    }
    // Add other-deduction item
    try {
      const otherDeductionItem = await addHocItem({
        amount,
        type: type as OtherDeductionItemType,
        userId,
        month,
        year,
        payslipId,
      });
      updateOtherDeductionItems(otherDeductionItem);
      if (otherDeductionItem) {
        toast({
          title: "Other deduction item added",
          description: `Other deduction item ${
            OtherDeductionItemTypeLabels[type as OtherDeductionItemType]
          } added successfully`,
        });
        setErr("");
        setType("");
        setAmount(0);
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Failed to add other-deduction item",
        variant: "destructive",
      });
    }
  };
  return (
    <div className="flex gap-2 flex-col mt-3">
      <div className="flex gap-2 items-end">
        <Dropdown
          label="Type"
          items={otherDeductionItemTypeArray}
          selectedString={type}
          setSelectedString={setType}
        />
        <NumberInput
          label="Amount"
          value={amount}
          setValue={setAmount}
          placeholder="Amount"
        />
        <Button onClick={handleOtherDeductionItem} type="submit">
          Add
        </Button>
      </div>
      {err && <div className="text-red-500 text-sm">{err}</div>}
    </div>
  );
}

export default AddOtherDeductionForm;
